<template>
  <div class="billing__fields">
    <InputComponent
      v-model="value.company"
      :label="$t('company')"
      data-field="company"
      required
      :is-valid="validator.fields['billing.company'].valid"
      :validation-message="validator.fields['billing.company'].error"
    />
    <InputComponent
      v-model="value.organizationNumber"
      :label="$t('orgNo')"
      data-field="orgNumber"
      required
      :is-valid="validator.fields['billing.organizationNumber'].valid"
      :validation-message="validator.fields['billing.organizationNumber'].error"
    />
    <InputComponent
      v-model="value.email"
      :label="$t('email')"
      data-field="email"
      required
      :is-valid="validator.fields['billing.email'].valid"
      :validation-message="validator.fields['billing.email'].error"
    />
    <Address
      v-model="value.address"
      :show-map="false"
      data-field="address"
      :validator="validator"
      validator-prefix="billing.address"
    />
  </div>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import Address from '@/components/Address.vue'
import { i18n } from '@/i18n'

const meta = {
  order: 4,
  label: i18n.tc('invoice'),
}

export { meta }

export default {
  props: {
    value: Object,
    validator: Object,
  },
  computed: {
    label: () => meta.label,
  },
  components: {
    InputComponent,
    Address,
  },
}
</script>

<style lang="scss">
.billing {
  &__fields {
    $cols: 2;

    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: 1rem;
    padding: 1rem;

    [data-field='address'],
    [data-field='email'] {
      grid-column-end: span $cols;
    }
  }
}
</style>
